export const PeopleViewType = {
  families: 'families',
  individuals: 'individuals',
};
